import { CargaFornecedor } from "./carga-fornecedor";
import { CargaLocal } from "./carga-local";
import { CargaProfissionais } from "./carga-profissionais";
import { DefinirEquipeObraDialog } from "./components/definir-equipe-obra";
import { PapeisObraDialog } from "./components/papeis-obra-dialog";
import { AplicarSimulacaoDialog } from "./components/simulacao/aplicar-simulacao-dialog";
import { CompararSimulacaoDialog } from "./components/simulacao/comparar-simulacao-dialog";
import { ConfirmarSimulacaoDialog } from "./components/simulacao/confirmar-simulacao-dialog";
import { HistoricoSimulacaoDialog } from "./components/simulacao/historico-simulacao-dialog";
import { JustificativaConflitosDialog } from "./components/simulacao/justificativa-conflitos-dialog";
import { SimulacaoBanner } from "./components/simulacao/simulacao-banner";
import type { CargaAba, CargaDeTrabalhoViewModel } from "./types-carga-de-trabalho";
import styles from "./carga-de-trabalho.module.scss";

function AbaDaPerspectiva({ aba }: { aba: CargaAba }) {
  if (aba.perspectiva === "profissionais") return <CargaProfissionais {...aba.props} />;
  if (aba.perspectiva === "fornecedor") return <CargaFornecedor {...aba.props} />;
  return <CargaLocal {...aba.props} />;
}

/** Carga de Trabalho: uma tela por perspectiva (Profissionais, Fornecedores e Locais) e os modais do Modo Simulação. */
export function CargaDeTrabalhoView({
  abas,
  banner,
  justificativa,
  comparar,
  arquivar,
  historico,
  aplicar,
  papeis,
  equipe,
}: CargaDeTrabalhoViewModel) {
  return (
    <>
      {banner ? <SimulacaoBanner {...banner} /> : null}

      {abas.map((aba) => (
        <div
          key={aba.chave}
          className={styles.perspectiva}
          hidden={aba.oculta}
          data-testid={aba.testId}
        >
          <AbaDaPerspectiva aba={aba} />
        </div>
      ))}

      {justificativa ? <JustificativaConflitosDialog {...justificativa} /> : null}
      {comparar ? <CompararSimulacaoDialog {...comparar} /> : null}
      {arquivar ? <ConfirmarSimulacaoDialog {...arquivar} /> : null}
      {historico ? <HistoricoSimulacaoDialog {...historico} /> : null}
      {aplicar ? <AplicarSimulacaoDialog {...aplicar} /> : null}
      {papeis ? <PapeisObraDialog {...papeis} /> : null}
      {equipe ? <DefinirEquipeObraDialog {...equipe} /> : null}
    </>
  );
}
